export default {
  "content": "<path fill=\"#000\" fill-opacity=\".54\" fill-rule=\"evenodd\" d=\"M2 4.667c0 .366.3.666.667.666h10.666c.367 0 .667-.3.667-.666C14 4.3 13.7 4 13.333 4H2.667C2.3 4 2 4.3 2 4.667zM7.333 12h1.334c.366 0 .666-.3.666-.667 0-.366-.3-.666-.666-.666H7.333c-.366 0-.666.3-.666.666 0 .367.3.667.666.667zm4-3.333H4.667A.669.669 0 014 8c0-.367.3-.667.667-.667h6.666c.367 0 .667.3.667.667 0 .367-.3.667-.667.667z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 16 16"
  }
};